(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cf-footer"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".footer-accordion");
  const headers = document.querySelectorAll(".footer-accordion-header");

  // ---- OPEN FIRST ACCORDION BY DEFAULT ---- //
  if (accordions.length > 0) {
    const first = accordions[0];
    first.classList.add("active");
    const firstContent = first.querySelector(".footer-accordion-content");
    firstContent.style.maxHeight = firstContent.scrollHeight + "px";
  }

  // ---- OPEN ONE AT A TIME ---- //
  headers.forEach(header => {
    header.addEventListener("click", function () {
      const parent = this.parentElement;

      // If already active, close it
      if (parent.classList.contains("active")) {
        parent.classList.remove("active");
        parent.querySelector(".footer-accordion-content").style.maxHeight = "0px";
        return;
      }

      // Close all
      accordions.forEach(acc => {
        acc.classList.remove("active");
        acc.querySelector(".footer-accordion-content").style.maxHeight = "0px";
      });

      // Open clicked accordion
      parent.classList.add("active");
      const content = parent.querySelector(".footer-accordion-content");
      content.style.maxHeight = content.scrollHeight + "px";
    });
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-tab"] && !Shopify.designMode) return;
  try {
    
const collectionTab = document.querySelectorAll(".collection-tab-button");
const collectionTabPanel = document.querySelectorAll(".collection-tab-panel");

let current = null;

/* 🔹 Default first tab active */
// if (collectionTab.length) {
//   collectionTab[0].classList.add("active");
// }

/* 🔹 Click → scroll to tab panel */
collectionTab.forEach((tab) => {
  tab.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href");
    if (!targetId || !targetId.startsWith("#")) return;

    const targetSection = document.querySelector(targetId);
    if (!targetSection) return;

    e.preventDefault();

    // Update active immediately on click
    collectionTab.forEach((t) => t.classList.remove("active"));
    this.classList.add("active");

    const offset = 120; // adjust for sticky header
    const top =
      targetSection.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  });
});

/* 🔹 Scroll → update active tab */
window.addEventListener("scroll", () => {
  collectionTabPanel.forEach((section) => {
    const sectionTop = section.offsetTop;
    if (window.scrollY >= sectionTop - 130) {
      current = section.getAttribute("id");
    }
  });

  if (!current) return;

  collectionTab.forEach((tab) => {
    tab.classList.toggle(
      "active",
      tab.getAttribute("href") === `#${current}`
    );
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const featuredCollectionSlider = document.querySelector('#featured-collection-slider');
    if (featuredCollectionSlider) {
      new Splide(featuredCollectionSlider, {
        perPage: 3,
        perMove: 1,
        speed: 1000,
        rewind: false,
        gap: '22px',
        arrows: true,
        pagination: false,
        breakpoints: {
          1024: {
            perPage: 3
          },
          991: {
            perPage: 2
          },
          767: {
            perPage: 3,
            gap: '11px',
          },
          576: {
            perPage: 2,
          },
        }
      }).mount();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot-splide"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  var splide = new Splide('#hotspotSplide', {
    type: 'slide',
    perPage: 1,
    gap: '16px',
    arrows: true,
    pagination: true,
    speed: 600,
    type: 'fade', 
  });

  splide.mount();

  const hotspots = document.querySelectorAll(".hotspot-dot");

  if(hotspots.length > 0){
    hotspots[0].classList.add("active-hotspot");
  }

  splide.on('move', function (newIndex) {
    hotspots.forEach(dot => dot.classList.remove("active-hotspot"));
    hotspots.forEach(dot => {
      if (parseInt(dot.dataset.slide) === newIndex) {
        dot.classList.add("active-hotspot");
      }
    });
  });

  hotspots.forEach(dot => {
    dot.addEventListener("mouseenter", function () {
      hotspots.forEach(d => d.classList.remove("active-hotspot"));
      this.classList.add("active-hotspot");
      const slideIndex = Number(this.dataset.slide);
      splide.go(slideIndex);
    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["outlast-product"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
        const items = document.querySelectorAll(".outlast-product");
        if (items.length > 0) {
            items[0].classList.add("hovered");
        }
        items.forEach((item) => {
            item.addEventListener("mouseenter", () => {
            items.forEach((i) => i.classList.remove("hovered"));
            item.classList.add("hovered");
            });
            item.addEventListener("mouseleave", () => {
            });
        });

        const wrapper = document.querySelector('.outlast-product_wrapper');
        const nextBtn = document.querySelector('.outlast-product-arrow.next');
        const prevBtn = document.querySelector('.outlast-product-arrow.prev');

        if (!wrapper) return;

        const card = wrapper.querySelector('.outlast-product');
        const gap = 16;
        const scrollAmount = card.offsetWidth + gap;

        function updateArrows() {
            const scrollLeft = wrapper.scrollLeft;
            const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

            // Disable Prev
            if (scrollLeft <= 0) {
            prevBtn.classList.add('disabled');
            } else {
            prevBtn.classList.remove('disabled');
            }

            // Disable Next
            if (scrollLeft >= maxScroll - 5) {
            nextBtn.classList.add('disabled');
            } else {
            nextBtn.classList.remove('disabled');
            }
        }

        // Click Events
        nextBtn.addEventListener('click', () => {
            wrapper.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
            });
        });

        prevBtn.addEventListener('click', () => {
            wrapper.scrollBy({
            left: -scrollAmount,
            behavior: 'smooth'
            });
        });

        // Update on scroll
        wrapper.addEventListener('scroll', updateArrows);

        // Initial state
        updateArrows();

        new Splide('#outlastSplide', {
            perPage: 3,
            gap: '10px',
            pagination: false,
            arrows: false,
            autoplay: false,
            padding: {
                left: '0',
                right: '20px'
            },
            breakpoints: {
                768: {
                    perPage: 2   
                },
                576: {
                    perPage: 1   
                }
            }
        }).mount();
    });


  } catch(e) { console.error(e); }
})();
})();
